import swal from "sweetalert";
import {
  CREATE_WHATS_APP_FAIL,
  CREATE_WHATS_APP_REQUEST,
  CREATE_WHATS_APP_SUCCESS,
  FETCH_WHATS_APP_FAIL,
  FETCH_WHATS_APP_REQUEST,
  FETCH_WHATS_APP_SUCCESS,
  UPDATE_WHATS_APP_FAIL,
  UPDATE_WHATS_APP_REQUEST,
  UPDATE_WHATS_APP_SUCCESS,
} from "../../ActionType/WhatsAppType/WhatsAppType";
import { api } from "../../Api/api";
import { getToken } from "../login";
import { getVisitAction } from "../VisitAction/VisitAction";

export const getWhatsAppAction =
  (
    page,
    perPage,
    branchId,
    fullname,
    code,
    organLevel,
    doctor,
    hospital,
    patient,
    zad,
    helpdoctor,
    totalOfSurgery,
    nameOfHospital,
    date,
    reject,
    from, to
  ) =>
    async (dispatch) => {
      const config = {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        params: {
          branch_id: branchId,
          page,
          perPage,
          fullname,
          code,
          organLevel,
          doctor,
          hospital,
          patient,
          zad,
          helpdoctor,
          totalOfSurgery,
          nameOfHospital,
          date,
          reject,
          from,
          to
        },
      };
      dispatch({
        type: FETCH_WHATS_APP_REQUEST,
        payload: [],
      });

      try {
        const response = await api.get("whatsApp", config);
        const { status, data } = response;

        if (status == 200) {
          dispatch({
            type: FETCH_WHATS_APP_SUCCESS,
            payload: { data: data.data, total: data.total },
          });
        }
      } catch (error) {
        if (error.response.status) {
          localStorage.removeItem('token')

        }
        dispatch({
          type: FETCH_WHATS_APP_FAIL,
          payload: [],
          error: error.response.data.errors,
        });
      }
    };

export const createWhatsAppAction =
  (
    visit_id,
    branch_id,
    patient,
    zad,
    hospital,
    doctor,
    totalOfSurgery,
    date,
    nameOfHospital,
    patientId
  ) =>
    async (dispatch) => {
      const config = {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      };
      dispatch({
        type: CREATE_WHATS_APP_REQUEST,
        payload: [],
      });

      try {
        const response = await api.post(
          "whatsApp/create",
          {
            visit_id,
            branch_id,
            patient,
            zad,
            hospital,
            doctor,
            total_of_surgery: totalOfSurgery,
            date,
            hospital_id: nameOfHospital?.value ? nameOfHospital?.value : nameOfHospital,
          },
          config
        );
        const { status, data } = response;

        if (status == 201) {
          dispatch({
            type: CREATE_WHATS_APP_SUCCESS,
            payload: data,
          });
          swal({
            title: "Good job!",
            text: "What App  was saved Successfully !",
            icon: "success",
            button: "OK",
            timer: 2000,
          });


        }
      } catch (error) {
        console.log("error ", error)
        dispatch({
          type: CREATE_WHATS_APP_FAIL,
          payload: [],
          error: error.response.data.errors,
        });
      }
    };

export const updateWhatsAppAction =
  (
    id,
    visit_id,
    branch_id,
    patient,
    zad,
    hospital,
    doctor,
    totalOfSurgery,
    date,
    nameOfHospital,
    patientId
  ) =>
    async (dispatch) => {
      const config = {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      };
      dispatch({
        type: CREATE_WHATS_APP_REQUEST,
        payload: [],
      });

      let tempNameofHospital = nameOfHospital?.value ? nameOfHospital?.value : nameOfHospital;
      nameOfHospital = tempNameofHospital;

      
      try {
        const response = await api.put(
          "whatsApp/update/" + id,
          {
            visit_id,
            branch_id,
            patient,
            zad,
            hospital,
            doctor,
            total_of_surgery: totalOfSurgery,
            date,
            hospital_id: nameOfHospital,
          },
          config
        );
        const { status, data } = response;
        if (status == 200) {
          console.log(response)
          swal({
            title: "Good job!",
            text: "What App  was updated Successfully !",
            icon: "success",
            button: "OK",
            timer: 2000,
          });
          console.log(data)
          dispatch({
            type: CREATE_WHATS_APP_SUCCESS,
            payload: data,
          });
        }
      } catch (error) {
        console.log("error", error)
        dispatch({
          type: CREATE_WHATS_APP_FAIL,
          payload: [],
          error: error.response.data.errors,
        });
      }
    };
export const exportToExcel = async (from, to) => {
  const branch_id = localStorage.getItem("branch_id");
  const config = {
    headers: {
      // "Content-Type": "multipart/form-data",
      // Accept: "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    params: {
      from,
      to,
      branch_id,
      reject: 0
    },
    responseType: "blob",
  };
  try {
    const response = await api.get("whatsApp/export", config);

    const blob = new Blob([response.data], { type: "text/csv" });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);

    link.download = "واتسئاپ.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error downloading CSV:", error);
  }
};
